import './styles.scss'
import React from 'react'
import { SelectWithLabel } from 'components/Form'
import { lang } from 'utils/helpers'

/**
 * Select
 * @param {object} props
 * @param {String} props.label
 * @param {String} props.placeholder
 * @param {Array} props.options
 */
const Select = (props) => {
  const { label, placeholder, options, description, onChange, value, required } = props
  const _options = options.map(it => ({ value: it.value, label: lang(it.label) }))

  return (
    <div className='channel-field select'>
      {label && <label>{lang(label)} <span className='required'>{required ? '*' : ''}</span></label>}
      <div className='field-content grid grid--small'>
        <SelectWithLabel
          placeholder={placeholder || lang('dashboard_select')}
          options={_options}
          onChange={(value) => onChange(value.value)}
          value={value ? _options.find(it => it.value === value) : ''}
        />
        {description && <p className='description'>{lang(description)}</p>}
      </div>
    </div>
  )
}

export default Select
